module.exports = __webpack_public_path__ + "img/icon_1.16cc0da4.svg";